/* eslint camelcase: "off" */
import React from 'react'
import { ApolloProvider } from 'react-apollo'
import { client } from '../shared/ApolloClient'
import PropTypes from 'prop-types'

import AppDetails from './AppDetails'

const AppDetailsContainer = ({ loanId, productName, customerService, superUser, partnerSettingsEnabled }) => {
  return (
    <ApolloProvider client={client}>
      <AppDetails
        loanId={loanId}
        productName={productName}
        customerService={customerService}
        superUser={superUser}
        partnerSettingsEnabled={partnerSettingsEnabled}
      />
    </ApolloProvider>
  )
}

AppDetailsContainer.propTypes = {
  loanId: PropTypes.number.isRequired,
  productName: PropTypes.string,
  customerService: PropTypes.bool,
  partnerSettingsEnabled: PropTypes.bool,
  superUser: PropTypes.bool
}

export default AppDetailsContainer
